import * as React from 'react'
import * as ReactRouter from 'react-router-dom'
import PropTypes from 'prop-types'
import { typography } from 'styled-system'

import * as common from '@rushplay/common'
import css from '@styled-system/css'
import styled from '@emotion/styled'

import { Heading } from './heading'

export const NavigationLink = styled(ReactRouter.NavLink)`
  white-space: nowrap;
  text-decoration: none;
  padding: 14px 16px;
  color: #4bbaeb,
  scroll-snap-align: start;
  ${css({
    color: 'nav-item',
    '&.active, &:hover': {
      color: 'white',
      borderRadius: '9999px',
      background: 'linear-gradient(180deg, #130830 0%, #1E0E5B 101.57%)',
      boxShadow: `inset 0px 0px 0px 1px #0E9FFF`,
    },
  })};
  ${typography};
`

export const SearchLink = styled(ReactRouter.NavLink)`
white-space: nowrap;
text-decoration: none;
padding: 14px 16px;
color: #4bbaeb,
scroll-snap-align: start;
  ${css({
    color: 'lavender',
    '&.active, &:hover': {
      opacity: '0.8',
    },
  })};
  ${typography};
`

const ScrollableRow = styled.div`
  overflow-y: hidden;
  overflow-x: scroll;
  padding-top: 4px;
  display: flex;
  column-gap: 15px;
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
  scroll-snap-type: inline mandatory;
  background-color: #311779;

  ${css({
    px: '8px',
    mx: '16px',
    borderBottomRightRadius: [null, null, null, '9999px'],
    borderTopRightRadius: [null, null, null, '9999px'],
    scrollPaddingInline: ['16px', '24px'],
  })};

  -webkit-overflow-scrolling: touch;

  @media (hover: hover) {
    ::-webkit-scrollbar {
      height: 4px;
      background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: transparent;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
`

export function PageNavigation(props) {
  return (
    <React.Fragment>
      {props.header && (
        <common.Space pb="2" px={[1, 2]}>
          <Heading level={2} color="page-nav-heading">
            {props.header}
          </Heading>
        </common.Space>
      )}
      <ScrollableRow>{props.children}</ScrollableRow>
    </React.Fragment>
  )
}

PageNavigation.propTypes = {
  header: PropTypes.string,
  children: PropTypes.node.isRequired,
}
